import React from "react";

/**
 * Simple React error boundary. Prevents a single render exception from
 * killing the entire page (which would freeze all event handlers, making
 * even unrelated buttons look "dead"). Used to wrap the Settings panels
 * and the template editor so any lookup crash degrades to a friendly
 * message instead of a blank / interactive-dead page.
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("[ErrorBoundary]", this.props.label || "unknown", error, info);
    }

    reset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (!this.state.hasError) return this.props.children;
        const msg = String(this.state.error?.message || this.state.error || "Something went wrong.");
        return (
            <div
                data-testid={`error-boundary-${this.props.label || "generic"}`}
                style={{
                    background: "#FDECEB",
                    border: "1px solid #F5C2C7",
                    color: "#842029",
                    borderRadius: 10,
                    padding: "14px 16px",
                    margin: "12px 0",
                    fontSize: 13,
                    lineHeight: 1.5,
                }}
            >
                <div style={{ fontWeight: 600, marginBottom: 4 }}>
                    Something went wrong in this section.
                </div>
                <div style={{ opacity: 0.85, fontFamily: "monospace", fontSize: 12, marginBottom: 8 }}>
                    {msg}
                </div>
                <button
                    onClick={this.reset}
                    style={{
                        background: "#842029", color: "#fff", border: "none",
                        borderRadius: 6, padding: "4px 12px", fontSize: 12, cursor: "pointer",
                    }}
                >
                    Try again
                </button>
            </div>
        );
    }
}
